// extracted by mini-css-extract-plugin
export default {"root":"OneStepBidding-module-root","bidControls":"OneStepBidding-module-bidControls","bidControl":"OneStepBidding-module-bidControl","bidButton":"OneStepBidding-module-bidButton"};